var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningStandar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 37.439,
    viewBox: "17 18.281 40 37.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.548 50.121 40.315 20.25a3.763 3.763 0 0 0-6.615 0L17.478 50.12a3.763 3.763 0 0 0 3.307 5.598h32.456a3.763 3.763 0 0 0 3.307-5.551ZM35.511 27.67a1.636 1.636 0 1 1 3.273 0v14.025a1.636 1.636 0 1 1-3.273 0V27.67Zm1.636 23.2a2.104 2.104 0 1 1 0-4.208 2.104 2.104 0 0 1 0 4.207Z",
    fill: "#fbbd2d",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningStandar);
export default __webpack_public_path__ + "static/media/warning-standar.f292881108f3285f4ae587f17f8bcefc.svg";
export { ForwardRef as ReactComponent };